import { get } from 'lodash';

// local dependencies
import { HttpService } from 'core/modules/network-service';
import { SERVICE_RESPONSE_STATUS } from 'constants/common';
import { getVisibleItems } from 'resolvers/getVisibleEntities';
import { REDUCER } from 'constants/entity-names';
import { getStore } from 'store';


// get store
const store = getStore();

/*************************************************************/

/**
 * @type {class}
 * @desc ReactivateEpostWidget defines an HTTP service interface to send HTTP network requets.
 * @example
 * import { ReactivateEpostWidgetService } from 'services/reactivateEpostWidget';
 *
 * // create service instance and send/cancel request
 * const reactivateEpostWidgetService = new ReactivateEpostWidgetService();
 * const result = await reactivateEpostWidgetService.fetchData( '<user-id>' ); // fetch data
 * reactivateEpostWidgetService.cancel(); // cancel an active request
 */
export class ReactivateEpostWidgetService extends HttpService {

    // fetch data from the backend
    async fetchComponentData( { url = {}, data = {} } = {} ) {

        // get ongoing call info from the redux store
        const callId = get( store.getState()[ REDUCER.CALL_STATE ], 'callId', null );

        try {
            const response = await this.post( {
                host: CONFIG.host,
                path: url,
                data: {
                    context: { callId },
                    data: data,
                }
            } );

            const steps = get( response, 'body.component.structure.steps', [] );
            const visibility = get( response, 'body.component.visibility', {} );

            return {
                status: get( response, 'body.status', SERVICE_RESPONSE_STATUS.FAILURE ),
                data: {
                    steps: getVisibleItems( steps, visibility ),
                    currentStep: get( response, 'body.component.data.state.currentStep', 1 )
                }
            };
        } catch( error ) {
            return {
                status: SERVICE_RESPONSE_STATUS.FAILURE,
                data: null,
            };
        }
    }
}
